import {IObservable, mkObservable} from "./Observable";
export const share = () => <T>(source: IObservable<T>): IObservable<T> => mkObservable(observer => source.subscribe({
  next: i => observer.next(i),
  error: err => observer.error(err),
  complete: () => observer.complete()
}));
